<script setup lang="ts">
// Vue & Plugins
import { ref, computed } from 'vue'
import { refDebounced  } from '@vueuse/core'
import { useInfiniteQuery } from '@tanstack/vue-query'

// Composables
import { groupOptionsInfinite } from '../../composables/useGroup'

// Models
import { SiteID } from '../../../sites/models/site'
import { Group } from '../../models/group'

const selected = defineModel<Group | null>('selected', { required: true })

const {
  siteId,
} = defineProps<{
    siteId: SiteID
}>()

const nameInput = ref('')
const name = refDebounced(nameInput, 500)

const isOpen = ref(false)
const {
  data,
  isFetching,
} = useInfiniteQuery({
  ...groupOptionsInfinite(() => siteId, { name }),
  enabled: isOpen,
})

const groups = computed<Group[]>(() => data?.value?.pages.reduce((acc, curr) => { return acc.concat(curr.groups) }, [] as Group[]) ?? [])

const optionsCombined = computed(() => 
  !selected.value ? groups.value : [selected.value, ...groups.value]
)
const options = computed(() => 
  Array.from(
    new Map(optionsCombined.value.map(item => [item.id, item])).values()
  )
)
</script>

<template>
  <Select
    v-model="selected"
    :options="options"
    :loading="isFetching"
    filter
    option-label="name"
    placeholder="Select Group"
    @filter="nameInput = $event.value"
    @show="isOpen = true"
    @hide="isOpen = false"
  >
    <template #value="slotProps">
      <template v-if="slotProps.value">
        <span style="color: var(--p-select-color)">{{ slotProps.value.name }}</span>
      </template>
      <span v-else>
        {{ slotProps.placeholder }}
      </span>
    </template>
  </Select> 
</template>
